import { forwardRef, type Ref, type SVGProps } from "react";
const IconLinkOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.68 21.21a6.68 6.68 0 0 1-4.72-2 1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0 4.68 4.68 0 0 0 6.61 0l4.86-4.8a4.67 4.67 0 1 0-6.6-6.6l-2 2A1 1 0 0 1 15.83 7l2-2a6.68 6.68 0 0 1 9.44 9.44l-4.87 4.81a6.66 6.66 0 0 1-4.72 1.96"
    />
    <path
      fill="currentColor"
      d="M8.89 30a6.68 6.68 0 0 1-4.72-11.39L9 13.75a6.67 6.67 0 0 1 9.43 0 1 1 0 0 1 0 1.41 1 1 0 0 1-1.41 0 4.68 4.68 0 0 0-6.61 0L5.59 20a4.67 4.67 0 1 0 6.6 6.6l2-2a1 1 0 0 1 1.42 1.4l-2 2a6.65 6.65 0 0 1-4.72 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLinkOutlineSVG);
ForwardRef.displayName = "IconLinkOutline";
export { ForwardRef as IconLinkOutline };
